if($('footer#footer').length == 1){
  $('nav#navigation ul.menu-level-1>li.detska-obuv>ul').wrapInner('<ul class="menu-level-middle"></ul>')
  $('nav#navigation ul.menu-level-1>li.detska-obuv>ul').prepend($('footer#footer .popis-detske.menu-dsc'))
  $('nav#navigation ul.menu-level-1>li.detska-obuv>ul').append($('footer#footer .popis-detske.menu-banner'))

  $('nav#navigation ul.menu-level-1>li.obuv-pro-dospele>ul').wrapInner('<ul class="menu-level-middle"></ul>')
  $('nav#navigation ul.menu-level-1>li.obuv-pro-dospele>ul').prepend($('footer#footer .popis-dospele.menu-dsc'))
  $('nav#navigation ul.menu-level-1>li.obuv-pro-dospele>ul').append($('footer#footer .popis-dospele.menu-banner'))

  $('nav#navigation ul.menu-level-1>li.damska-obuv>ul').wrapInner('<ul class="menu-level-middle"></ul>')
  $('nav#navigation ul.menu-level-1>li.damska-obuv>ul').prepend($('footer#footer .popis-damska.menu-dsc'))
  $('nav#navigation ul.menu-level-1>li.damska-obuv>ul').append($('footer#footer .popis-damska.menu-banner'))

  $('nav#navigation ul.menu-level-1>li.panska-obuv>ul').wrapInner('<ul class="menu-level-middle"></ul>')
  $('nav#navigation ul.menu-level-1>li.panska-obuv>ul').prepend($('footer#footer .popis-panska.menu-dsc'))
  $('nav#navigation ul.menu-level-1>li.panska-obuv>ul').append($('footer#footer .popis-panska.menu-banner'))

  $('nav#navigation ul.menu-level-1>li.doplnky>ul').wrapInner('<ul class="menu-level-middle"></ul>')
  $('nav#navigation ul.menu-level-1>li.doplnky>ul').prepend($('footer#footer .popis-doplnky.menu-dsc'))
  $('nav#navigation ul.menu-level-1>li.doplnky>ul').append($('footer#footer .popis-doplnky.menu-banner'))
}

if($('footer#footer').length == 0){
    $('body').append('<footer id="footer" class="hide"></footer>')
    if (!sessionStorage.footer) {
        $(document).on("ready", function(){
          $("footer#footer").load("/ footer#footer", function(){
            sessionStorage.footer = $("footer#footer").html();
          });
        })
      } else {
        $("footer#footer").append(sessionStorage.footer);
    };
    $(document).on("ready", function(){
        setTimeout(function(){ 
          $('nav#navigation ul.menu-level-1>li.barefoot-detska-obuv>ul').wrapInner('<ul class="menu-level-middle"></ul>')
          $('nav#navigation ul.menu-level-1>li.barefoot-detska-obuv>ul').prepend($('footer#footer .popis-detske.menu-dsc'))
          $('nav#navigation ul.menu-level-1>li.barefoot-detska-obuv>ul').append($('footer#footer .popis-detske.menu-banner'))
        
          $('nav#navigation ul.menu-level-1>li.obuv-pro-dospele>ul').wrapInner('<ul class="menu-level-middle"></ul>')
          $('nav#navigation ul.menu-level-1>li.obuv-pro-dospele>ul').prepend($('footer#footer .popis-dospele.menu-dsc'))
          $('nav#navigation ul.menu-level-1>li.obuv-pro-dospele>ul').append($('footer#footer .popis-dospele.menu-banner'))
        
          $('nav#navigation ul.menu-level-1>li.damska-obuv>ul').wrapInner('<ul class="menu-level-middle"></ul>')
          $('nav#navigation ul.menu-level-1>li.damska-obuv>ul').prepend($('footer#footer .popis-damska.menu-dsc'))
          $('nav#navigation ul.menu-level-1>li.damska-obuv>ul').append($('footer#footer .popis-damska.menu-banner'))
        
          $('nav#navigation ul.menu-level-1>li.panska-obuv>ul').wrapInner('<ul class="menu-level-middle"></ul>')
          $('nav#navigation ul.menu-level-1>li.panska-obuv>ul').prepend($('footer#footer .popis-panska.menu-dsc'))
          $('nav#navigation ul.menu-level-1>li.panska-obuv>ul').append($('footer#footer .popis-panska.menu-banner'))
        
          $('nav#navigation ul.menu-level-1>li.doplnky>ul').wrapInner('<ul class="menu-level-middle"></ul>')
          $('nav#navigation ul.menu-level-1>li.doplnky>ul').prepend($('footer#footer .popis-doplnky.menu-dsc'))
          $('nav#navigation ul.menu-level-1>li.doplnky>ul').append($('footer#footer .popis-doplnky.menu-banner'))
        }, 1000)
    })
}
/*
$(window).on('load', function(){
    $('body').addClass('submenu-visible')
    $('nav#navigation ul.menu-level-1>li.'+druhy_blok_link+'').addClass('exp')
})*/